'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throwError = throwError;
exports.isFunc = isFunc;
exports.isString = isString;
function throwError(msg) {
  throw new Error(msg);
}

function isFunc(val) {
  return typeof val === 'function';
}

function isString(val) {
  return typeof val === 'string';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-action/build/util.js
// module id = 65
// module chunks = 0